module.exports = __webpack_public_path__ + "img/裂开.b9444c8d.png";